<div class="dashboard">
  <div class="dashboard-header">
    <h1 class="main-title">Analytics Dashboard</h1>
  </div>

  <div class="top-grid">
    <div class="usage-card">
      <div class="usage-header">
        <h2>Service Usage Distribution</h2>
        <div class="usage-total">42,43M</div>
      </div>
      <div class="chart-wrapper">
        <p-chart type="line" [data]="chartData" [options]="chartOptions" [style]="{ height: '100%', width: '100%' }">
        </p-chart>
      </div>
    </div>

    <div class="kpi-stack">
      <div class="kpi-card" [ngClass]="{'gradient-card': i === 0, 'white-card': i !== 0}"
        *ngFor="let kpi of kpis; let i = index">
        <div class="kpi">
          <div class="kpi-icon">
            <i class="pi" [ngClass]="kpi.icon"></i>
          </div>
          <div class="kpi-info">
            <div class="stat-count">{{ kpi.value }}</div>
            <p>{{ kpi.label }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="subscription-card">
    <div class="sub-header">
      <h2>Subscription</h2>
    </div>
    <div class="sub-grid">
      <div class="sub-item">
        <span class="dot orange"></span>
        <span class="sub-label">Premium Subscriptions</span>
        <span class="spacer"></span>
        <span class="sub-count">50</span>
      </div>
      <div class="sub-item">
        <span class="dot blue"></span>
        <span class="sub-label">Add-on Services</span>
        <span class="spacer"></span>
        <span class="sub-count">50</span>
      </div>
      <div class="sub-item">
        <span class="dot purple"></span>
        <span class="sub-label">One-time Purchases</span>
        <span class="spacer"></span>
        <span class="sub-count">50</span>
      </div>
      <div class="sub-item">
        <span class="dot green"></span>
        <span class="sub-label">Enterprise Plans</span>
        <span class="spacer"></span>
        <span class="sub-count">50</span>
      </div>
    </div>
  </div>

  
</div>